<template>
   <v-row>
      <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto'"
      >
        <span
          class="float-right"
          style="z-index:6;position: sticky;"
        >
          <v-menu
            v-if="mobile() && role != 'guest' && role != 'participant'"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-2"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list
              class="py-0 horizontal-list-menu mobile-menu"
              flat
              style="z-index: 9 !important"
            >
              <v-list-item
                  @click="seeAll"
                  data-testid="dashboard-item"
                  :class="{'accent--text': $route.name ==='Dashboard'}"
                  background-color="background"
              >
                  <v-list-item-title>{{ $t('dashboard') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                  v-if="(role == 'booster' || role == 'space_admin') 
                    && productPlan.attributes 
                    && productPlan.attributes.workflow_module == 1
                    && ($route.name === 'Dashboard' || $route.name === 'MyWorkflows' || $route.name === 'AllHubs' || $route.name === 'AllActivities' || $route.name === 'AllCertificates')"         
                  @click="showWorkflowsPage"
                  data-testid="workflows-item"
                  :class="{'accent--text': $route.name ==='MyWorkflows'}"
              >
                  <v-list-item-title>
                    {{ $t('workflow') }}
                    <v-icon v-if="workflowBroken" color="red" size="16" class="ml-1">
                      mdi-alert
                    </v-icon>
                  </v-list-item-title>
              </v-list-item>
              <v-list-item
                  @click="showActivityPage"
                  v-if="$route.name === 'Dashboard' || $route.name === 'MyWorkflows' || $route.name === 'AllHubs' || $route.name === 'AllActivities' || $route.name === 'AllCertificates'"
                  data-testid="activities-item"
                  :class="{'accent--text': $route.name ==='AllActivities'}"
              >
                  {{ $t('activitiesItem') }}
              </v-list-item> 
              <v-list-item 
                  @click="showhubPage"
                  v-if="$route.name === 'Dashboard' || $route.name === 'MyWorkflows' || $route.name === 'AllHubs' || $route.name === 'AllActivities' || $route.name === 'AllCertificates'"
                  :disabled="productPlan.attributes && productPlan.attributes.name === 'Free'" 
                  data-testid="hubs-item"
                  :class="{'accent--text': $route.name ==='AllHubs'}"
              >
                  {{ $t('hubItem') }}
                  <v-chip v-if="productPlan.attributes && productPlan.attributes.name == 'Free'" class="rounded-lg ml-2 px-2"  style="position: absolute;  top: 16px; left:55px" x-small color="accent" text-color="white">PRO</v-chip>
              </v-list-item> 
              <v-list-item 
                  @click="showCertificatesPage"
                  v-if="$route.name === 'Dashboard' || $route.name === 'MyWorkflows' || $route.name === 'AllHubs' || $route.name === 'AllActivities' || $route.name === 'AllCertificates'"
                  data-testid="certificates-item"
                  :class="{'accent--text': $route.name ==='MyCertificates'}"
              >
                  {{ $t('myCertificatesItem') }}
              </v-list-item> 
              <v-list-item
                  @click="showEventsPage"
                  data-testid="events-item"
                  :class="{'accent--text': $route.name ==='MyEvents'}"
              >
                  {{ $t('eventsItem') }}
              </v-list-item>
            </v-list> 
          </v-menu>
          <v-menu
            v-if="role == 'guest' || role == 'participant'"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-2"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list
              class="py-0 horizontal-list-menu mobile-menu"
              flat
              style="z-index: 9 !important"
            >
              <v-list-item
                  @click="seeAll"
                  data-testid="dashboard-item"
                  :class="{'accent--text': $route.name === 'ActivitiesParticipant'}"
                  background-color="background"
              >
                  <v-list-item-title>{{ $t('dashboard') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                  @click="showActivityPage"
                  data-testid="activities-item"
                  :class="{'accent--text': $route.name === 'AllActivitiesParticipant'}"
              >
                  {{ $t('activitiesItem') }}
              </v-list-item> 
              <v-list-item 
                  @click="showhubPage"
                  v-if="productPlan.attributes && productPlan.attributes.name !== 'Free'"
                  data-testid="hubs-item"
                  :class="{'accent--text': $route.name === 'AllHubsParticipant'}"
              >
                  {{ $t('hubItem') }}
              </v-list-item>
              <v-list-item
                  @click="showCertificatesPage"
                  data-testid="certificates-item"
                  :class="{'accent--text': $route.name ==='MyCertificatesParticipant'}"
              >
                  {{ $t('myCertificatesItem') }}
              </v-list-item>
              <v-list-item
                  @click="showEventsPage"
                  data-testid="events-item"
                  :class="{'accent--text': $route.name ==='MyEventsParticipants'}"
              >
                  {{ $t('eventsItem') }}
              </v-list-item>
          </v-list> 
          </v-menu>
        </span>
        <p v-if="mobile()"
          class="text-h5 font-weight-bold ml-16 mr-16"
          :align="mobile() ? 'center' : 'center'"
        >
          {{ $t('home') }}
        </p>
        <p v-else
          class="welcome-text font-weight-bold"
          :align="mobile() ? 'center' : 'center'"
        >
          {{ $t('dashboardHeaderWelcome') }}
        </p>
      </v-col>
      <v-col
        v-if="!mobile()"
        cols="11"
        background-color="background"
        :class="mobile() ? 'custom-tab-menu py-0' : 'mx-auto custom-tab-menu py-0 justify-center d-flex'"
      >
        <HorizontalListMenu v-if="role != 'guest' && role != 'participant'" data-testid="horizontal-list-menu" />
      </v-col>
    </v-row>
</template>
<script>
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import HorizontalListMenu from '../components/HorizontalListMenu'
export default {
    mixins: [repeatedMethodsMixin],
    props: {
    },
    components: {
      HorizontalListMenu,
    },
    data: function() {
        return { 
            searchClosed:true,
            search: null,
            spaceId: window.$cookies.get('space_id'),
            role: localStorage.space ? JSON.parse(localStorage.space).role : null,
        }
    },
    computed: {
        productPlan() {
            return this.$store.state.productPlan;
        },
        workflowBroken() {
            return this.$store.state.workflowBroken;
        },
        sizeHubs() {
          switch (this.$vuetify.breakpoint.name) {
            case 'xl': return 3
            default: return 2
          }
        },
        sizeActivities() {
          switch (this.$vuetify.breakpoint.name) {
            case 'xl': return 4
            default: return 6
          }
        },
    },
    watch: {
        search(val) {
            if (val == null || val == '') {
                this.search = null
                this.$emit('resetSearch', val)
            }else{
                let searchkey = val.trim()
                if (searchkey.length < 2) return
                this.$emit('input', searchkey)
            }
            
        },      
    },
    methods: {
        openSeach(){
        if(!this.searchClosed){
            this.search = null
            this.$nextTick(() => {
                this.searchClosed = true
            })
        }else {
            this.searchClosed = false
        }
        },
        seeAll(){
            if (this.role == 'space_admin' || this.role == 'booster') {
                this.$router.push({path: '/dashboard'}) 
            } else if (this.role == 'participant' || this.role == 'guest') {
                this.$router.push({path: '/dashboard-participant'})
            }
        },
        showWorkflowsPage(){
           this.$router.push({path: '/workflows'})
        },
        showActivityPage(){
            if (this.role == 'space_admin' || this.role == 'booster') {
                this.$router.push({path: '/all-activities'}) 
            } else if (this.role == 'participant' || this.role == 'guest') {
                this.$router.push({path: '/all-activities-participant'})
            } 
        },
        showhubPage(){
            if (this.role == 'space_admin' || this.role == 'booster') {
                this.$router.push({path: '/all-hubs'}) 
            } else if (this.role == 'participant' || this.role == 'guest') {
                this.$router.push({path: '/all-hubs-participant'})
            }
        },
        showCertificatesPage(){
            if (this.role == 'space_admin' || this.role == 'booster') {
                this.$router.push({path: '/shared-with-me/certificates'})
            } else if (this.role == 'participant' || this.role == 'guest') {
                this.$router.push({path: '/certificates-participant'})
            }
        },
        showEventsPage(){
            if (this.role == 'space_admin' || this.role == 'booster') {
                this.$router.push({path: '/events'})
            } else if (this.role == 'participant' || this.role == 'guest') {
                this.$router.push({path: '/events-participant'})
            }
        },
    },
}

</script>
<style>
.welcome-text {
  font-size: 60px;
  text-transform: uppercase;
  color: #3565B3;
  display: none;
}
.welcome-text-mobile {
  font-size: 30px;
  text-transform: uppercase;
  color: #3565B3;
}
.mobile-menu {
  background-color: var(--v-primary-lighten5) !important;
}
</style>